import http from './httpService';

export function fetchUserApi() {
  return http.get(`/account`);
}

// export function getAllComments() {
//   return http.get(`/comments`);
// }
// comments?riskId.equals=${id}&sort=createdAt,desc

export function getAllCommentsPaginated(id) {
  return http.get(`/comments?riskId.equals=${id}&sort=dateCreated,desc`);
}

export function createComments(formData) {
  return http.post(`/comments`, formData);
}
